import { gql } from '@apollo/client';

export const CREATE_CALLBACK = gql`
  mutation CreateCallback($input: CreateCallbackInput!) {
    createCallback(input: $input) {
      callbackId
    }
  }
`;

export const CREATE_APPOINTMENT = gql`
  mutation CreateAppointment($input: CreateAppointmentInput!) {
    createAppointment(input: $input) {
      appointmentId
      contactId
      officeId
    }
  }
`;
